var map = {
	"./date.de-CH.json": 885,
	"./date.de-DE.json": 886,
	"./date.en-CA.json": 887,
	"./date.en-GB.json": 888,
	"./date.en-IN.json": 889,
	"./date.en-ME.json": 890,
	"./date.en-US.json": 891,
	"./date.es-EM.json": 892,
	"./date.es-ES.json": 893,
	"./date.fr-BE.json": 894,
	"./date.fr-CA.json": 895,
	"./date.fr-CH.json": 896,
	"./date.nl-BE.json": 897,
	"./date.nl-NL.json": 898,
	"./date.pl-PL.json": 899,
	"./date.pt-BR.json": 900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 884;